import { useEffect, useState } from "react";
import { Map as MapIcon, ExternalLink, Loader2 } from "lucide-react";
import api from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const BoundaryLinks = ({ links, compact = false, prefix = "boundary" }) => (
  <div className="flex flex-wrap gap-1.5">
    {links.map((l) => (
      <a key={l.id} href={l.url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
        data-testid={`${prefix}-link-${l.id}`}
        className={`inline-flex items-center gap-1 rounded-full border px-2.5 font-medium transition-colors hover:bg-secondary ${compact ? "h-7 text-[11px]" : "h-8 text-xs"} ${l.id === "onx" ? "border-amber-500/50 text-amber-300" : "border-border text-foreground"}`}>
        <ExternalLink className="h-3 w-3" />{l.label}
      </a>
    ))}
  </div>
);

const RefImage = ({ orderId, data }) => {
  const [ok, setOk] = useState(true);
  const src = data.outline ? `${BACKEND_URL}/api/orders/${orderId}/parcel-outline.jpg` : data.image_url;
  if (!src || !ok) return null;
  return (
    <a href={src} target="_blank" rel="noreferrer" className="block overflow-hidden rounded-lg border border-border">
      <div className="relative">
        <img src={src} alt={data.outline ? "Satellite view with parcel outline" : "Satellite view of the property"} loading="lazy"
          onError={() => setOk(false)} className="aspect-[3/2] w-full object-cover" data-testid="boundary-image" />
        {!data.outline && <span className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-amber-500 shadow" />}
      </div>
    </a>
  );
};

export const BoundaryReference = ({ orderId }) => {
  const [ref, setRef] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}/boundary-reference`).then(({ data }) => setRef(data)).catch(() => setRef({ links: [] }));
  }, [orderId]);

  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="boundary-panel">
      <h3 className="flex items-center gap-2 text-sm font-semibold"><MapIcon className="h-4 w-4 text-amber-400" /> Property Lines Reference</h3>
      {!ref ? (
        <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Finding the parcel outline…</div>
      ) : (
        <div className="mt-3 space-y-3">
          <RefImage orderId={orderId} data={ref} />
          <p className="text-[11px] text-muted-foreground" data-testid="boundary-source">
            {ref.outline
              ? `Parcel outline from ${ref.outline_source}. Double-check it in onX Hunt before tracing.`
              : "No public parcel data for this county yet. Use onX Hunt to see the lines."}
          </p>
          <BoundaryLinks links={ref.links || []} />
        </div>
      )}
    </div>
  );
};
